var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReordersetGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 61,
    viewBox: "0 0 55 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_37_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7293 2.02281C15.1826 2.03134 16.4093 2.0356 17.3213 2.52108C17.9187 2.83912 18.4143 3.29531 18.7579 3.84378C19.2826 4.681 19.2787 5.80251 19.2709 8.04559C19.2631 10.2887 19.2592 11.4102 18.7287 12.2437C18.3813 12.7898 17.8826 13.2425 17.283 13.5564C16.3675 14.0355 15.1409 14.0313 12.6876 14.0227C10.2343 14.0142 9.00761 14.0099 8.09553 13.5245C7.49813 13.2064 7.00254 12.7502 6.659 12.2018C6.13428 11.3646 6.13818 10.243 6.14597 7.99996C6.15377 5.75689 6.15767 4.63538 6.6882 3.80182C7.03555 3.25575 7.5343 2.80302 8.13389 2.48914C9.04933 2.01002 10.276 2.01428 12.7293 2.02281Z",
    stroke: "#5DEE7A",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 20.0227C15.12 20.0312 16.3467 20.0355 17.2588 20.521C17.8562 20.839 18.3518 21.2953 18.6953 21.8437C19.22 22.6809 19.2161 23.8024 19.2083 26.0455C19.2005 28.2885 19.1966 29.41 18.6661 30.2436C18.3188 30.7896 17.82 31.2424 17.2204 31.5562C16.305 32.0354 15.0783 32.0311 12.625 32.0226C10.1717 32.0141 8.94505 32.0098 8.03297 31.5243C7.43557 31.2063 6.93998 30.75 6.59644 30.2017C6.07172 29.3644 6.07562 28.2429 6.08341 25.9998C6.09121 23.7568 6.09511 22.6353 6.62563 21.8017C6.97298 21.2557 7.47174 20.8029 8.07133 20.489C8.98676 20.0099 10.2134 20.0142 12.6667 20.0227Z",
    stroke: "#5DEE7A",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6042 38.0226C15.0575 38.0311 16.2841 38.0354 17.1962 38.521C17.7936 38.8389 18.2892 39.2952 18.6327 39.8436C19.1575 40.6808 19.1536 41.8023 19.1458 44.0454C19.138 46.2884 19.1341 47.4099 18.6035 48.2435C18.2562 48.7895 17.7574 49.2423 17.1579 49.5561C16.2424 50.0353 15.0158 50.0311 12.5625 50.0225C10.1091 50.014 8.88249 50.0097 7.97041 49.5242C7.37301 49.2062 6.87742 48.75 6.53387 48.2016C6.00916 47.3643 6.01305 46.2428 6.02085 43.9997C6.02865 41.7567 6.03255 40.6352 6.56307 39.8016C6.91042 39.2556 7.40918 38.8028 8.00877 38.489C8.9242 38.0098 10.1509 38.0141 12.6042 38.0226Z",
    stroke: "#5DEE7A",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2709 8.04559L35.0208 8.10034C41.2079 8.12185 44.3015 8.1326 46.2175 9.89663C48.1335 11.6607 48.1236 14.4891 48.104 20.1459L48.0956 22.5459M48.0623 32.1458C48.0426 37.8026 48.0328 40.631 46.1046 42.3818C44.1763 44.1324 41.0828 44.1216 34.8956 44.1001L27.0207 44.0728M27.0207 44.0728L32.254 48.891M27.0207 44.0728L32.2873 39.291",
    stroke: "#5DEE7A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_37_79",
    x: 0.0189819,
    y: 0.0206451,
    width: 54.0889,
    height: 60.004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37_79"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_37_79",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReordersetGreen);
export default __webpack_public_path__ + "static/media/reorderset-green.b78317b2747f1aa5023032566747afc9.svg";
export { ForwardRef as ReactComponent };